module.exports = __webpack_public_path__ + "static/media/location-512.72acbd58.png";